import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Setor {
  id: number;
  nome: string;
}

@Injectable({
  providedIn: 'root'
})
export class SetorService {
  //private apiUrl = 'https://localhost:7103/api/Setor'; // Altere para sua API correta

  //constructor(private http: HttpClient) { }

  //getSetores(): Observable<Setor[]> {
    //return this.http.get<Setor[]>(this.apiUrl);
  //}

   private baseUrl = environment.apiUrlExbeOn;
    private endpoint = '/Setor';
    constructor(private http: HttpClient) { }
  
    getSetores(): Observable<Setor[]> {
      return this.http.get<Setor[]>(`${this.baseUrl}${this.endpoint}`);
    }
}
